export function PhoneQuestions({ pharmacy = false }: { pharmacy?: boolean }): React.JSX.Element {
  return <details className="phone-questions"><summary>전화할 때 물어보세요</summary><ul>
    <li>{pharmacy ? "오늘 몇 시까지 이용할 수 있나요?" : "오늘 진료를 받을 수 있나요? 접수는 몇 시까지인가요?"}</li>
    <li>{pharmacy ? "처방전에 적힌 약을 조제할 수 있나요?" : "점심시간이나 휴진 시간이 있나요?"}</li>
    {!pharmacy && <><li>아이 진료라면, 아이 나이에도 진료를 받을 수 있나요?</li><li>필요한 검사·진료를 오늘 받을 수 있나요? 예약이나 준비물이 필요한가요?</li></>}
  </ul><small>필요한 항목만 전화로 물어보세요. 답변이나 건강정보를 이 화면에 입력하지 않습니다.</small></details>;
}
